import "./style/DivContent.css";
function DivContent(props) {
  return <div className="DivContent">{props.children}</div>;
}

export default DivContent;
